var _path, _path2, _circle, _path3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysMultiCity = function SvgSysMultiCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeDasharray: "3 3",
    strokeLinecap: "round",
    d: "M3.5 16.569c1.172-.298 3.678-.853 6.139-.394 3.468.646 3.436 1.832 5.194 2.427 1.759.595 2.736.347 5.667.347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.5 7.73c0 3.809-4 6.77-4 6.77s-4-2.961-4-6.77c0-1.121.421-2.197 1.172-2.99A3.893 3.893 0 0 1 7.5 3.5c1.06 0 2.078.446 2.828 1.24A4.358 4.358 0 0 1 11.5 7.73Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7,
    r: 1.5,
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.5 10.346c0 3.462-3.5 6.154-3.5 6.154s-3.5-2.692-3.5-6.154c0-1.02.369-1.998 1.025-2.72C15.181 6.907 16.072 6.5 17 6.5c.928 0 1.819.405 2.475 1.127.656.72 1.025 1.7 1.025 2.72Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 10,
    r: 1.5,
    stroke: "currentColor"
  })));
};
export default SvgSysMultiCity;